<div class="video-modal">
  <div class="modal-header image-header">
    <button type="button"
            class="btn-close"
            aria-label="Close"
            (click)="closePopup()"></button>
  </div>
  <div class="modal-body image-body">
    <div class="row">
      <div class="col">
        <label class="info-label">{{studyFile?.patientName}}</label>
        <br />
        <label class="info-label">{{studyFile?.dicomPatientId}}</label>
      </div>
      <div class="col-auto">
        <img class="xray-image" [src]="url" />
      </div>
      <div class="col text-end">
        <label class="info-label">{{studyFile?.physiciansOfRecord}}</label>
        <br />
        <label class="info-label">{{studyFile?.studyDateTime | date: 'MMM dd, YYYY hh:mm:ss'}}</label>
      </div>
    </div>
    <!--<div class="flex align-items-center justify-content-center">
    
    </div>-->

  </div>
</div>
